import { Component, OnInit } from '@angular/core';
import { ModalPopUpService } from './modal-popup.service';
import { HttpRequestService } from '../../services/http-request.service';
import { Utils } from '../../services/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.css'],
  providers: [DialogService]
 
})
export class ModalPopupComponent implements OnInit {

  tableSource: any[];
  tableConfigs: any;
  tableColumnConfigs: any[];
  gridCallBacks: any = {};

  filterTemplate: any[];
  filterConfig: any;
  selectedItem: any = [];
  isFormOnly = false;
  isDisabled = false;
  additionalButtonDetails: any[];

  constructor(private modalPopupService: ModalPopUpService,
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private authService: AuthService,
    private httpService: HttpRequestService,
    private dialogService: DialogService,
    private utils: Utils) { }

  fetchTableSource() {
    const configData = this.config.data;
    const configs = this.modalPopupService.getControlConfigs();
    const reqData = configData.requestData;
    
    this.isFormOnly = !!configData.isFormOnly;
    
    if(configData && configData.additionalButtonDetails){
      this.additionalButtonDetails = configData.additionalButtonDetails
    }

    if (this.isFormOnly) {
      this.filterTemplate = configData.formTemplate;
      this.filterConfig = configData.formConfig;
      this.utils.mapArrayToFormDropdowns(this.filterTemplate, configData.comboSource);
      this.filterConfig.formGroup = this.utils.constructFormControlGroup(this.filterTemplate, configData.formData, configData.comboSource);
      return;
    }

    if (configData.canSkipApicall) {
      const tConfigs = configs.tableConfigs;
      this.tableConfigs = tConfigs;
      this.tableColumnConfigs = configs.tableTemplate;
      this.tableSource = configData.gridData;
      return;
    }
    this.loadData();
  }

  loadData(refresh?){
    const configData = this.config.data;
    const configs = this.modalPopupService.getControlConfigs();
    const reqData = configData.requestData;
    const selectedControl = configs.filterConfig['selectedControl'] ? configs.filterConfig['selectedControl'] : configs.tableConfigs['selectedControl'];
    let requestData;
    if (reqData) {
      requestData = this.utils.constructRequestData(reqData, configs.workFlowName, configs.requestMethodName);
    } else {
      requestData = ({
        'workFlowName': configs.workFlowName,
        'processType': 'Screen',
        'workFlowParams': JSON.stringify({
          'methodName': configs.requestMethodName,
          'strToken': this.authService.getAuthorizationToken(),
          'strUserId': this.authService.getLoggedUserName()
        })
      });
    }

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response: any) => {
        this.tableSource = configs.constructSource(response, configs.compScope, false, selectedControl);
        if (this.config.data.canRemoveExisitingData) {
          this.tableSource = this.utils.removeExistingItemInDest(this.config.data.existingData, this.tableSource, this.config.data.key);
        }
        
        if(refresh){
          let sourceData = configs.constructSource(response, configs.compScope, false, selectedControl);
          this.tableSource = sourceData;
          this.utils.insertIdFieldInDataSource(sourceData);
          this.gridCallBacks['scope'].dataset = sourceData;
          this.gridCallBacks['scope'].dataViewObj.refresh();
        }
        this.tableColumnConfigs = configs.tableTemplate;

        const tConfigs = configs.tableConfigs;
        tConfigs['enableCheckboxSelector'] = true;
        tConfigs['rowSelectionOptions'].selectActiveRow = this.config.data ? !(this.config.data.enableMultiSelect) : true;
        this.tableConfigs = tConfigs;
        if (configs.constructSource && configs.filterConfig) {
          this.filterTemplate = configs.constructSource(response, configs.compScope, true, selectedControl);
          this.filterConfig = configs.filterConfig;
        }
      }, () => {
        this.onClickClose();
      }
    );
  }

  buttonClick(btnIndex){
    if(this.additionalButtonDetails[btnIndex]){
      this.additionalButtonDetails[btnIndex].callback(this);
    }
  }

  onRowDoubleClicked(event) {
    const item = this.gridCallBacks['scope'].dataViewObj.getItem(event.selectedRowDetails.row);
    this.selectedItem.push(item);
    this.onClickOk();
  }

  onFilterGrid(filterData) {
    const configs = this.modalPopupService.getControlConfigs();
    if (filterData.isReset) {
      configs.filterMethodName = configs.requestMethodName;
      delete filterData.isReset;
    }
    const requestData = {
      workFlowName: configs.workFlowName,
      workFlowParams: JSON.stringify({
        'methodName': configs.filterMethodName,
        ...filterData
      })
    };
    this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response: any) => {
        const gridData = configs.constructSource(response, configs.compScope, false, configs.filterConfig['selectedControl']);
        this.utils.insertIdFieldInDataSource(gridData);
        this.gridCallBacks['scope'].dataset = gridData;
        this.gridCallBacks['scope'].dataViewObj.refresh();
      },
      (errResponse) => {
      }
    );
  }

  onClickOk() {
    if (this.isFormOnly) {
      this.ref.close(this.filterConfig.formGroup.getRawValue());
      return;
    }
    const selectedItem = this.config.data.canSkipApicall ? this.gridCallBacks.scope.dataset : (this.selectedItem.length ? this.selectedItem : this.gridCallBacks['getSelectedRows'](this.gridCallBacks['scope']));
    this.ref.close(this.config.data.canSkipApicall || this.config.data && this.config.data.enableMultiSelect ? selectedItem : selectedItem[0]);
  }

  onClickClose() {
    this.ref.close();
  }

  onGridSelectionChanges(event) {
    if (this.config.data.canValidateGridRowSelection) {
      this.isDisabled = !event.rows.length;
    }
  }

  ngOnInit() {
    this.isDisabled = !!this.config.data.canValidateGridRowSelection;
    this.fetchTableSource();
  }
}
